(ns rothko.theme.manatee.header
  (:refer-clojure :exclude [rem])
  (:require [garden.units :refer [rem]]
            [rothko.theme.manatee.colours :refer [colours]]))

(def header-height (rem 6))

(def main
  {:primary
   {:background-color (:blue-dark colours)}
   :evaluator
   {:background-color (:purple colours)}})
